import React from 'react';

type Person = {
  agentID?: string
  firstName?: string
  lastName?: string
}

export function PersonColumnFormatter(person: Person): JSX.Element {
  const {agentID, firstName, lastName} = person;

  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
      <div>{agentID ?? ''}</div>
      <div>{[firstName, lastName].filter(Boolean).join(' ')}</div>
    </div>
  )
}